export const isMigratedToProtobuf = (
  id: string
): id is
  | 'review'
  | 'self-checkin'
  | 'check-bus-tickets'
  | 'check-ticket'
  | 'voucher'
  | 'nol-chat' =>
  ['review', 'self-checkin', 'check-bus-tickets', 'check-ticket', 'voucher', 'nol-chat'].includes(
    id
  )
